import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { vars } from 'src/core/themes';
import { NoData } from 'src/tables/Table';
import { Table } from 'src/tables/TableV2/Table';
import { ContentId } from 'src/utils/constants/contentId';
import {
  SponsoredListingsCampaign,
  SponsoredListingsFlight,
} from 'src/WebApiController';

import { getTableColumnDefinitions } from './PastFlightsTableColumnsConfig';

export type PastFlightsTableProps = {
  isLoading: boolean;
  campaignsAndFlights:
    | [SponsoredListingsCampaign, SponsoredListingsFlight][]
    | null
    | undefined;
};

export const PastFlightsTable: React.FC<PastFlightsTableProps> = ({
  isLoading,
  campaignsAndFlights,
}) => {
  if (isLoading) {
    return <PosSpinner />;
  }

  return campaignsAndFlights?.length ? (
    <ColumnResizingContextProvider>
      <Table<[SponsoredListingsCampaign, SponsoredListingsFlight]>
        useVirtuoso
        actionColId={'actions'}
        data={campaignsAndFlights}
        columns={getTableColumnDefinitions()}
        getRowId={(data, index) => String(data?.[1].flightId ?? index)}
        getItemId={(data) => String(data?.[1].flightId)}
        state={{
          sorting: [{ id: 'startDate', desc: true }],
        }}
      />
    </ColumnResizingContextProvider>
  ) : (
    <NoData style={{ border: `1px solid ${vars.color.borderPrimary}` }}>
      <Content id={ContentId.None} />
    </NoData>
  );
};
